import { Pipe, PipeTransform } from '@angular/core';
import { RDMClientService } from '../services/rdm-client.service';
import { TranslateService } from '@ngx-translate/core';

@Pipe({ name: 'rdmtranslate' })

export class RdmTranslatePipe implements PipeTransform {

  constructor(private rdmClientService: RDMClientService, private translateService: TranslateService) { }
  transform(code: string|any, rdmLabel: string) {
    return this.getRdmDataByRefTypeAndCode(code, rdmLabel);
  }

  getRdmDataByRefTypeAndCode(code: string,rdmLabel: string,): string {
    const [item] = this.rdmClientService.getRefValues(rdmLabel).filter((item:any) => item.code == code);
    if (item) return item.label;
    else return this.translateService.instant('intelligencemgmt.na');
  }
}
